<template>
  <div>
    <!--顶部介绍-->
    <!--<picture>-->
    <!--  <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/bakTop.png">-->
    <!--  <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/bakTop.png">-->
    <!--  <img class="bakTop" src="@/assets/img/pc/about/about2/bakTop.png">-->
    <!--</picture>-->
    <guide :guide="guide" :color="'rgb(90, 137, 227)'" style="position: relative;top: 2rem;"></guide>
    <!--主体内容-->
    <div class="x-container">
      <!--搜索框-->
      <div class="topBar">
        <el-input
          v-model="keyWords"
          placeholder="使用关键词或问题搜索"
          style="font-size: 0.9rem;"
          clearable
          @clear="searchData"
        >
          <i slot="suffix" class="el-input__icon el-icon-search canClick" @click="searchData"></i>
        </el-input>
      </div>
      <!--产品资料-->
      <template v-for="(faq,index) in FAQList">
        <section :key="'faq'+index" class="card">
          <div class="title">{{ faq.problem }}</div>
          <div class="content">{{ faq.answer }}</div>
          <div class="content">{{ '所属产品：' + faq.productCenterName }}</div>
          <div class="content">{{ '更新时间：' + faq.updateTime }}</div>
        </section>
      </template>
    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'
  import {selectAllQuestionsAnswersList} from "../../../api/FAQcommunity";

  export default {
    name: "FAQcommunity",
    components: {
      guide,
    },
    data() {
      return {
        // 上方导航
        guide: [
          {label: '服务与支持'},
          {label: '问答社区'},
        ],

        // 查询关键词
        keyWords: '',

        // 问题列表
        FAQList: [
          {
            problem: '拆包原因以及解决方案？',
            answer: '直接这拆就好啦',
            productCenterName: 'GMOS开发软件',
            updateTime: '2023/6/28'
          }
        ],
      }
    },
    methods: {
      searchData() {
        let data = {};
        if (this.keyWords) {
          data.keyWords = this.keyWords
        }
        selectAllQuestionsAnswersList(data).then(res => {
          if (res.returnCode === '100') {
            this.FAQList = res.returnData;
          }
        }).catch(e => e);
      },
    },
    created() {
      this.searchData();
    }
  }
</script>

<style scoped lang="less">
  .x-container {
    section {
      width: 80%;
      margin: auto;
      margin-bottom: 2rem;
    }
  }

  /*头部背景图*/
  .bakTop {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }

  // 顶部操作栏
  .topBar {
    width: 80%;
    margin: 0 auto 2rem auto;
  }
  // 问题卡片
  .card {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    text-align: left;
    padding: 1rem;
    box-sizing: border-box;
    word-break: break-word;
    div {
      padding-bottom: 0.5rem;
    }
    .title {
      font-weight: bold;
      font-size: 0.95rem;
    }
    .content {
      font-size: 0.85rem;
    }
  }

  .canClick {
    cursor: pointer;
  }

  /deep/.topBar .el-input__clear {
    font-size: 0.9rem;
  }
</style>
